var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from "styled-components";
import { getColor, getStyle } from "./badge.utils";
export const BadgeWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ label, value }) => label && !value && "height: 1.25rem"}
`;
export const StyledBadge = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  > div {
    display: flex;
  }

  ${({ value, label, size }) => getStyle({ value, label, size })};

  ${(_a) => {
    var props = __rest(_a, []);
    return `background-color: ${getColor(Object.assign(Object.assign({}, props), { isLabel: false }))}`;
}};
`;
export const StyledValue = styled.div `
  ${({ color, theme }) => `color: ${color === "default" ? theme.colors.grey15 : theme.colors.white}`};
`;
export const StyledLabel = styled.div `
  padding-right: 0.125rem;
  ${(_a) => {
    var props = __rest(_a, []);
    return `color: ${getColor(Object.assign(Object.assign({}, props), { isLabel: true }))}`;
}}
`;
